import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IPreferredStaffListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

// GET the clinic preferred-doctor mappings (all clinics, or one via clinicId).
export const usePreferredStaffListAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (clinicId?: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios.get<IPreferredStaffListResponse>(CONFIGURATION_APIS.PREFERRED_STAFF_LIST.baseURL, {
          params: clinicId ? { clinic_id: clinicId } : {},
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        return response.data?.data ?? [];
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        }
        return [];
      }
    },
    [configuration, captureError, sendCurl],
  );

  return { execute };
};
